let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9CDY0"), load("jSnLP"), load("5JcBn"), load("aQp8v"), load("ffEVr"), load("2jsRt"), load("69F1b")]).then(() => parcelRequire('2QizT'));